// extracted by mini-css-extract-plugin
module.exports = {"graphContainer":"Chart_Village_Person_BarChart_graphContainer__3l9Ho"};